import { createApp } from 'vue'

import App from '@/App.vue'
import { vReveal } from '@/lib/reveal'
import { router } from '@/router'
import '@/style.css'

createApp(App).use(router).directive('reveal', vReveal).mount('#app')
